import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ConstructionPosition, MaterialParametrs } from '@api-gen';
import { FramePartitionDoubleComponent, FramePartitionSingleComponent, HeavyMultiLayerWallComponent, HeavyMultiLayerWallFacingBothSideComponent, HeavyMultiLayerWallFacingOneSideComponent, HeavyMultiLayerWallSoundproofBothSideComponent, HeavyMultiLayerWallSoundproofingOneSideComponent, HeavySingleLayerWallComponent, HeavySingleLayerWallFacingBothSideComponent, HeavySingleLayerWallFacingOneSideComponent, HeavySingleLayerWallSoundproofingBothSideComponent, HeavySingleLayerWallSoundproofingOneSideComponent, } from '@features';
import { ConstructionTypeEnum, MaterialTypeEnum } from '@features/guidbooks/types';
export var ConstructionTypeMap = function (_a) {
    var _b;
    var currentConstruction = _a.currentConstruction, currentForm = _a.currentForm;
    var setValue = currentForm.setValue;
    var typeMap = (_b = {},
        //TODO
        _b[ConstructionTypeEnum.HeavySingleWallFacing] = {
            component: _jsx(_Fragment, {}),
            action: function () { },
        },
        _b[ConstructionTypeEnum.HeavySingleLayerWall] = {
            component: _jsx(HeavySingleLayerWallComponent, { currentForm: currentForm }),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavySingleLayerWall);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.HeavySingleLayerWallFacingOneSide] = {
            component: _jsx(HeavySingleLayerWallFacingOneSideComponent, { currentForm: currentForm }),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavySingleLayerWallFacingOneSide);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Center,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.AirGap,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Frame,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.HeavySingleLayerWallFacingBothSide] = {
            component: _jsx(HeavySingleLayerWallFacingBothSideComponent, { currentForm: currentForm }),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavySingleLayerWallFacingBothSide);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Frame,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.AirGap,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Center,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Right,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.AirGap,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Frame,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.HeavySingleLayerWallSoundproofingOneSide] = {
            component: (_jsx(HeavySingleLayerWallSoundproofingOneSideComponent, { currentForm: currentForm })),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavySingleLayerWallSoundproofingOneSide);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Center,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.ZPanel,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.HeavySingleLayerWallSoundproofingBothSide] = {
            component: (_jsx(HeavySingleLayerWallSoundproofingBothSideComponent, { currentForm: currentForm })),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavySingleLayerWallSoundproofingBothSide);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.ZPanel,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Center,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Right,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.ZPanel,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.HeavyMultiLayerWall] = {
            component: _jsx(HeavyMultiLayerWallComponent, { currentForm: currentForm }),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavyMultiLayerWall);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '5',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.HeavyMultiLayerWallFacingOneSide] = {
            component: _jsx(HeavyMultiLayerWallFacingOneSideComponent, { currentForm: currentForm }),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavyMultiLayerWallFacingOneSide);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '5',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Center,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.AirGap,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Frame,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.HeavyMultiLayerWallFacingBothSide] = {
            component: _jsx(HeavyMultiLayerWallFacingBothSideComponent, { currentForm: currentForm }),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavyMultiLayerWallFacingBothSide);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.AirGap,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Frame,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Center,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '5',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Right,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.AirGap,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Frame,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.HeavyMultiLayerWallSoundproofingOneSide] = {
            component: (_jsx(HeavyMultiLayerWallSoundproofingOneSideComponent, { currentForm: currentForm })),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavyMultiLayerWallSoundproofingOneSide);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '5',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Center,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.ZPanel,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.HeavyMultiLayerWallSoundproofingBothSide] = {
            component: _jsx(HeavyMultiLayerWallSoundproofBothSideComponent, { currentForm: currentForm }),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.HeavyMultiLayerWallSoundproofingBothSide);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.ZPanel,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Center,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '5',
                                materialId: '',
                                materialType: MaterialTypeEnum.Heavy,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                    {
                        contructionPosition: ConstructionPosition.Right,
                        userMaterials: [
                            {
                                positionId: '0',
                                materialId: '',
                                materialType: MaterialTypeEnum.ZPanel,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '1',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.FramePartitionSingle] = {
            component: _jsx(FramePartitionSingleComponent, { currentForm: currentForm }),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.FramePartitionSingle);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Frame,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                            {
                                positionId: '5',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b[ConstructionTypeEnum.FramePartitionDouble] = {
            component: _jsx(FramePartitionDoubleComponent, { currentForm: currentForm }),
            action: function () {
                setValue('constructionTypeObject.constructionTypeEnum', ConstructionTypeEnum.FramePartitionDouble);
                setValue('constructionTypeObject.constructions', [
                    {
                        contructionPosition: ConstructionPosition.Left,
                        userMaterials: [
                            {
                                positionId: '2',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '3',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '4',
                                materialId: '',
                                materialType: MaterialTypeEnum.Frame,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                            {
                                positionId: '5',
                                materialId: '',
                                materialType: MaterialTypeEnum.AirGap,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '6',
                                materialId: '',
                                materialType: MaterialTypeEnum.Link,
                                materialTypeValue: [
                                    {
                                        materialParameters: MaterialParametrs.ConnectionNumber,
                                        value: '',
                                    },
                                ],
                            },
                            {
                                positionId: '7',
                                materialId: '',
                                materialType: MaterialTypeEnum.Frame,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Width, value: '' },
                                    { materialParameters: MaterialParametrs.RackStep, value: '' },
                                ],
                            },
                            {
                                positionId: '8',
                                materialId: '',
                                materialType: MaterialTypeEnum.Filler,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                            {
                                positionId: '8',
                                materialId: '',
                                materialType: MaterialTypeEnum.Board,
                                materialTypeValue: [
                                    { materialParameters: MaterialParametrs.Thickness, value: '' },
                                    { materialParameters: MaterialParametrs.Density, value: '' },
                                ],
                            },
                        ],
                    },
                ]);
            },
        },
        _b);
    return typeMap[currentConstruction];
};
